import { fetchWrapper } from '@/_helpers';
import {
    showConfirmationAlert,
    showErrorAlert,
    showLoadingAlert,
    showSuccessAlert,
} from '@/components/Admin/Form/FormBuilder/alerts';
import {
    getFormIdFromUrl,
    prepareFieldConfig,
    prepareFieldProperties,
    prepareFieldProperties2,
} from '@/components/Admin/Form/FormBuilder/utils';

export const addFormFieldApi = async (field, { formId: propFormId }) => {
    try {
        const formId = propFormId || getFormIdFromUrl();
        if (!field?.id || !formId) {
            return console.error('addFormFieldApi', { formId, field });
        }
        const body = { field, action: 'add' };
        return await fetchWrapper.post(`forms/${formId}/fields`, body);
    } catch (error) {
        console.error('addFormFieldApi', error);
        showErrorAlert(error);
    }
};

export const handleDeleteFormObj = async (formId) => {
    try {
        await fetchWrapper.delete(`forms/${formId}`);
        return true;
    } catch (err) {
        console.error('Delete form error:', err);
        throw new Error(err?.message || 'Something went wrong while deleting form');
    }
};

export const addFormField = (tempField, { formId: propFormId, hideSavingAlert, from, formElementIndex }) => {
    const formId = propFormId || getFormIdFromUrl();
    delete tempField.from;
    const field = tempField;
    field.options = prepareFieldProperties(field);
    field.config = prepareFieldConfig(field);
    field.fieldProperties = prepareFieldProperties2(field);
    console.log('addFormField:Props::', { formId, field, hideSavingAlert, from, formElementIndex });
    return async (dispatch) => {
        if (!field?.id || !formId) {
            return console.error('addFormField:Error:Missing form/fieldId', {
                formId,
                field,
                hideSavingAlert,
                from,
                formElementIndex,
            });
        }
        try {
            const body = { field, action: 'add', formElementIndex };
            if (from === 'PDFFieldMapper') {
                // during field mapping just save the data
                dispatch({
                    type: 'ADD_FORM_DATA',
                    payload: field,
                });
                await fetchWrapper.post(`forms/${formId}/fields`, body);
                return;
            }
            if (from === 'FormPicker') {
                showLoadingAlert('Adding Form Element...');
            } else {
                showLoadingAlert('Saving changes...');
            }
            const response = await fetchWrapper.post(`forms/${formId}/fields`, body);
            const { field: payload, actionFieldId } = response || {};
            payload.id = payload?._id || actionFieldId;
            payload.actionFieldId = actionFieldId;
            if (formElementIndex !== undefined) {
                payload.formElementIndex = formElementIndex;
            }
            dispatch({
                type: 'ADD_FORM_DATA',
                payload,
            });
            showSuccessAlert();
        } catch (error) {
            console.error('addFormField', error);
            if (field._id) {
                dispatch({
                    type: 'ADD_FORM_DATA',
                    payload: field,
                });
            }
            showErrorAlert(error);
        }
    };
};

export const deleteFormField = (fieldId, { formId: propFormId }) => {
    return async (dispatch) => {
        const formId = propFormId || getFormIdFromUrl();
        if (!fieldId || !formId) {
            return console.error('deleteFormField', { formId, fieldId });
        }
        const confirm = await showConfirmationAlert('Are you sure you want to delete this element?');
        if (!confirm.isConfirmed) return;

        try {
            showLoadingAlert('Saving changes...');
            const body = {
                action: 'delete',
                field: {
                    id: fieldId,
                },
            };
            if (fieldId.includes('-')) {
                dispatch({ type: 'DELETE_FORM_ELEMENT', payload: fieldId });
            } else {
                const response = await fetchWrapper.post(`forms/${formId}/fields`, body);
                const { actionFieldId } = response || {};
                dispatch({ type: 'DELETE_FORM_ELEMENT', payload: actionFieldId });
            }
            showSuccessAlert();
        } catch (error) {
            console.error('deleteFormField', error);
            showErrorAlert(error);
        }
    };
};

export const reorderFormField = (field, { formId: propFormId, formElementIndex }) => {
    const formId = propFormId || getFormIdFromUrl();
    delete field.from;
    console.log('reorderFormField:Props::', { formId, field, formElementIndex });
    return async (dispatch) => {
        if (!field?.id || !formId || formElementIndex === undefined) {
            return console.error('reorderFormField:Error:Missing form/fieldId', { formId, field, formElementIndex });
        }
        try {
            const body = { field, action: 'reorder', formElementIndex };
            const response = await fetchWrapper.post(`forms/${formId}/fields`, body);
            const { field: payload, actionFieldId } = response || {};
            payload.id = payload._id;
            payload.actionFieldId = actionFieldId;
            if (formElementIndex !== undefined) {
                payload.formElementIndex = formElementIndex;
            }
        } catch (error) {
            console.error('reorderFormField:Error', error);
        }
    };
};
export const deleteForm = () => {};
